<template>
	<div :class="{
		'moment': true,
		'moment--ocean': type === 'ocean',
		'moment--forest': type === 'forest',
		'moment--active': type === $store.state.toggledMoment
	}">
		<red-button @click.native="openMobile" aligned="right">Go there</red-button>
		<div class="moment__gallery">
			<img :src="photo('01')">
			<div>
				<img :src="photo('02')">
				<img :src="photo('03')">
			</div>
		</div>
		<div class="moment__copy">
			<header @click="toggleMoment">
				<img :src="icon">
				<h3><img :src="heading" :alt="headingAlt"></h3>
			</header>
			<p><slot></slot></p>
			<div class="moment__red-button-container">
				<red-button @click.native="open" :aligned="type === 'forest' ? 'left' : 'right'">TAKE ME THERE</red-button>
			</div>
		</div>
	</div>
</template>

<script>
import RedButton from './RedButton';

export default {
	components: { RedButton },
	props: {
		type: {
			type: String,
			required: true,
			validator: (value) => ['forest', 'ocean'].indexOf(value) !== -1,
		},
	},
	computed: {
		icon () {
			return require(`../assets/ico-${this.type}.svg`);
		},
		heading () {
			return require(`../assets/heading-${this.type}.svg`);
		},
		headingAlt () {
			return this.type.charAt(0).toUpperCase() + this.type.slice(1) + 's';
		},
	},
	methods: {
		photo (id) {
			return require(`../assets/photo-${this.type}-${id}.jpg`);
		},
		open (e) {
			e.preventDefault();
			this.$root.dispatchEvent('takeMeThere', {type: this.type});
			this.$emit('open', this.type);
		},
		openMobile (e) {
			e.preventDefault();
			this.$root.dispatchEvent('takeMeThere', {type: this.type});
			this.$emit('openMobile', this.type);
		},
		toggleMoment (e) {
			this.$root.dispatchEvent('takeMeThere', {type: this.type});
			this.$store.commit('toggleMoment', this.type);
		},
	},
};
</script>

<style lang="less" scoped>
	@import (reference) '../assets/_mixins.less';
	@import (reference) '../assets/_breakpoints.less';

	@height: 45vw;

	.moment { position: relative; display: flex; width: 50%; min-height: @height; padding: 5vw 0 5vw 5vw; transition: all 1s ease; z-index: 5;
		> a { display: none; }
		&__gallery { position: relative; z-index: 10; display: inline-flex; flex-direction: column; align-self: flex-start; width: 50%; box-shadow: 0 0 40px 5px fade(black, 20);
			> img:first-of-type { flex: 0 0 auto; }
			div { display: inline-flex; flex: 0 0 auto;
				img:first-child { width: 48.5%; height: 100%; }
				img:last-child { width: 51.5%; height: 100%; }
			}
		}
		&__copy { width: 50%; display: flex; flex-direction: column;
			header { display: inline; min-height: 13vw;
				> img { display: block; width: 2.5vw; margin: 0 auto; }
				h3 { width: 8vw; margin: 33px auto; text-align: center; }
			}
			p { position: relative; flex: 1 1 auto; padding: 2.5vw 4vw 2.5vw 2.5vw; color: white; font-size: 14px;
				&:before { position: absolute; top: 0; left: -25%; z-index: 3; content: ""; display: block; width: 110%; height: 1px; background: white; }
			}
		}
		&__red-button-container { width: 100%; }

		&--forest { background: transparent url(../assets/moment-forest.jpg) 100% 50% / cover no-repeat; }

		&--ocean { flex-direction: row-reverse; padding: 5vw 5vw 5vw 0; background: transparent url(../assets/moment-ocean.jpg) 0% 50% / cover no-repeat; }
		&--ocean &__copy {
			header {
				> img { width: 6vw; margin: 1vw auto 1vw; }
				h3 { width: 10vw; }
			}
			p {
				&:before { left: auto; right: -25%; }
			}
		}
	}

	@media @mobile {
		.moment { width: 100%; flex-direction: column-reverse; padding: 0; overflow: hidden; background-position: 50% 0%; background-size: cover;
			> a { display: block; margin: 50px auto; }
			&__copy { width: 85%; .center();
				header { text-align: center; display: flex; min-height: 160px; height: 160px; margin-top: 0; justify-content: center;
					> img { display: inline; width: 45px; margin: 0 45px 0 0; vertical-align: middle; }
					h3 { width: 120px; margin: auto 0; display: inline-block; vertical-align: middle; }
				}
				p { padding: 33px 0; border-top: 1px solid #fff;
					&:before { display: none; }
				}
				a { display: none; }
			}
			&__gallery { width: 85%; .center(); }

			&--ocean:after { .bottom-left(image-height('../assets/bg-delimiter-moments-mobile.png') / -2, 0); .size(100%, image-height('../assets/bg-delimiter-moments-mobile.png')); content: ""; display: block; background: transparent url(../assets/bg-delimiter-moments-mobile.png) 0 0 repeat-x; }
			&--forest:after { .top-left(image-height('../assets/bg-delimiter-moments-mobile.png') / -2, 0); .size(100%, image-height('../assets/bg-delimiter-moments-mobile.png')); content: ""; display: block; background: transparent url(../assets/bg-delimiter-moments-mobile.png) 0 0 repeat-x; }

			&--ocean &__copy header {
				> img { width: 80px; margin: 0 30px 0 0; }
				h3 { width: 120px; }
			}

			/** Transition */
			max-height: 160px; min-height: auto; transition: 2s all ease;
			> a { transform: translateX(-130%);  opacity: 0; transition: 2s transform ease, 1s opacity ease; }
			&__copy p { transform: translateX(130%); opacity: 0; transition: 2s transform ease, 1s opacity ease; }
			&__gallery { transform: translateX(-130%); opacity: 0; transition: 2s transform ease, 1s opacity ease; }

			&--active {
				max-height: 2000px;
				> a { transform: translateX(0);  opacity: 1; }
				.moment__copy p { transform: translateX(0); opacity: 1; }
				.moment__gallery { transform: translateX(0); opacity: 1; }
			}
		}
	}

	@media @tablet, @desktop {
		.moment { padding: 5vw 2vw;
			&__copy { width: 100%;
				p:before { width: ~"calc(100% - 5vw)"; left: 2.5vw; }
			}
			&__gallery { display: none; }
			&--ocean &__copy p:before { width: ~"calc(100% - 5vw)"; left: 2.5vw; right: auto; }
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/MomentsSectionItem.vue